{
  "en": {
    "chart": {
      "type": {
        "bar": "Bar chart",
        "bubble": "Bubble chart",
        "doughnut": "Doughnut chart",
        "horizontalBar": "Horizontal Bar chart",
        "line": "Line chart",
        "multiAxis": "Multi Axis chart",
        "pie": "Pie chart",
        "polarArea": "Polar area chart",
        "radar": "Radar chart",
        "stackedBar": "Stacked Bar chart"
      }
    }
  }
}
